import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import BrandLogo from './BrandLogo';
import { FiActivity, FiCrosshair, FiList, FiTrendingUp, FiSettings, FiHexagon, FiPlay } from 'react-icons/fi';

const navItems = [
  { path: '/', label: 'Overview', icon: FiActivity },
  { path: '/demo', label: 'Demo', icon: FiPlay },
  { path: '/radar', label: 'Bottleneck Radar', icon: FiCrosshair },
  { path: '/queues', label: 'Task Queues', icon: FiList },
  { path: '/workload', label: 'Team Workload', icon: FiTrendingUp },
  { path: '/playbooks', label: 'Playbooks', icon: FiHexagon },
  { path: '/settings', label: 'Settings', icon: FiSettings },
];

const Sidebar = () => {
  return (
    <aside className="w-64 h-screen border-r border-cyan-900/30 bg-slate-950/80 backdrop-blur-xl flex flex-col z-20">
      <div className="p-6 flex items-center space-x-3">
        <BrandLogo size="md" />
        <span className="text-xl font-bold text-white tracking-widest text-glow uppercase italic">OpsPrism</span>
      </div>

      <nav className="flex-1 px-4 py-6 space-y-1.5">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 group ${
                isActive
                  ? 'bg-cyan-950/40 text-cyan-300 border border-cyan-500/30 shadow-[inset_0_0_20px_rgba(6,182,212,0.1)]'
                  : 'text-slate-500 hover:bg-slate-900 hover:text-cyan-100 border border-transparent'
              }`
            }
          >
            <SafeIcon icon={item.icon} className="text-lg group-hover:drop-shadow-[0_0_8px_rgba(6,182,212,0.8)]" />
            <span className="font-medium text-sm tracking-wide">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="p-6 border-t border-cyan-900/20">
        <div className="flex items-center space-x-3 mb-4">
          <div className="w-8 h-8 rounded bg-slate-900 border border-slate-800 flex items-center justify-center text-[10px] font-bold text-slate-500">
            SYS
          </div>
          <div>
            <div className="text-[10px] font-bold text-slate-400 uppercase tracking-tighter">System Version</div>
            <div className="text-[10px] font-mono text-cyan-600">v4.0.2-STABLE</div>
          </div>
        </div>
        <p className="text-[9px] font-mono text-slate-600 uppercase tracking-widest text-center">
          Made by LingLink AI & DigLab AI
        </p>
      </div>
    </aside>
  );
};

export default Sidebar;